import PropTypes from 'prop-types'
import { useStyletron } from 'baseui'
import {
  IconWrapper,
  NotificationActions,
  NotificationContent,
  StyledNotification,
  TextWrapper,
} from './styled-components'
import IconCarbonMisuseOutline from '@/shared/icons/IconCarbonMisuseOutline'
import IconCarbonVoiceActivate from '@/shared/icons/IconCarbonVoiceActivate'
import IconCarbonInformation from '@/shared/icons/IconCarbonInformation'
import IconCarbonRocket from '@/shared/icons/IconCarbonRocket'
import IconCustomAgentScript from '@/shared/icons/IconCustomAgentScript'
import HandIcon from './icon_hand.svg'
import IconUnlocked from '@/shared/icons/NewDesign/IconUnlocked'
import IconLocked from '../../../icons/NewDesign/IconLocked'
import IconWarning from '@/shared/icons/NewDesign/IconWarning'
import IconVoice from '@/shared/icons/NewDesign/IconVoice'

const SDNotification = ({
  children,
  icon = true,
  type = '',
  boldText = false,
  hidden = false,
  primaryText,
  border = false,
  iconType,
  iconSize = 24,
  centerText = false,
  overrides = {},
}) => {
  const [, theme] = useStyletron()

  if (hidden) return null

  const showIcon = icon !== false && type !== ''
  const colors = {
    negative: theme.colors.negative,
    positive: theme.colors.positive,
    additionalSale: theme.colors.warning,
    warning: '#D2A604',
    default: '#0184EB',
  }
  const iconProps = { size: iconSize, color: colors[type] ?? colors.default }

  const getIcon = () => {
    const final = iconType ?? type
    switch (final) {
      case 'negative':
        return <IconCarbonMisuseOutline {...iconProps} />
      case 'warning':
        return <IconWarning {...iconProps} />
      case 'info':
        return <IconVoice {...iconProps} />
      case 'positive':
        return <img src={HandIcon} alt={primaryText} width={iconSize} height={iconSize} />
      case 'unlocked':
        return <IconUnlocked {...iconProps} />
      case 'locked':
        return <IconLocked {...iconProps} />
      case 'script':
        return <IconCarbonVoiceActivate {...iconProps} />
      case 'agentScript':
        return <IconCustomAgentScript {...iconProps} />
      case 'additionalSale':
        return <IconCarbonRocket {...iconProps} />
      default:
        return <IconCarbonInformation {...iconProps} />
    }
  }

  const renderedIcon = showIcon ? getIcon() : null

  return (
    <StyledNotification $type={type} $boldText={boldText} $border={border} {...overrides}>
      <NotificationContent $centerText={centerText}>
        {renderedIcon && <IconWrapper>{renderedIcon}</IconWrapper>}
        <TextWrapper $centerText={centerText}>
          <div dangerouslySetInnerHTML={{ __html: primaryText }} />
        </TextWrapper>
      </NotificationContent>
      {children && <NotificationActions>{children}</NotificationActions>}
    </StyledNotification>
  )
}

SDNotification.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.func, PropTypes.object]),
  type: PropTypes.oneOf([
    '',
    'additionalSale',
    'default',
    'negative',
    'positive',
    'script',
    'warning',
    'agentScript',
    'info',
    'unlocked',
    'locked',
  ]),
  boldText: PropTypes.bool,
  hidden: PropTypes.bool,
  primaryText: PropTypes.string,
  border: PropTypes.bool,
  iconType: PropTypes.string,
  iconSize: PropTypes.number,
  centerText: PropTypes.bool,
  overrides: PropTypes.object,
}

export default SDNotification
